import { render, staticRenderFns } from "./EudrSendDialog.vue?vue&type=template&id=9eb7e6a0&scoped=true&"
import script from "./EudrSendDialog.vue?vue&type=script&lang=js&"
export * from "./EudrSendDialog.vue?vue&type=script&lang=js&"
import style0 from "./EudrSendDialog.vue?vue&type=style&index=0&id=9eb7e6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb7e6a0",
  null
  
)

export default component.exports